// Version 1.0 
// project name :MVNOC PARTNER PLATFORM
// filename :layout.module.ts
// path :src\app\utils
// purpose: functions related to http requests
// author: apoorva
// version history: v1.0 initial version
// 
import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest ,  HttpParameterCodec} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './local-storage.service';
// import * as CryptoJS from 'crypto-js';
@Injectable({
    providedIn: 'root',
})


export class UtilsService {
  public Datashare : EventEmitter<any> = new EventEmitter<any>();
  public static BASE_URL = environment.API_URL
  public static S3_URL = environment.S3GATEWAY_URL
     public static IDENTITY_BASE_URL = UtilsService.BASE_URL
     public static S3_GATEWAY_BASE_URL = UtilsService.S3_URL

    //  public static  NEXUS_API_URL = "https://dev.api.nexus.mvnoc.ai"
  
// public static SIM_BASE_URL = UtilsService.BASE_URL+'sim/'
  public static LOGIN = UtilsService. IDENTITY_BASE_URL  + '/account/login'
  
  
//   Partner Portal URLS
public static  GET_SUBSCRIBER_INFORMATION = UtilsService. IDENTITY_BASE_URL  + '/partner/subscriber_information'   //partnersubscriberinformation
public static  GET_ORDERHISTORY_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/partner/order_history_summary'      //partnerorderhistorysummary
public static  GET_ORDERHISTORY_DETAILS = UtilsService. IDENTITY_BASE_URL  + '/partner/order_history_details'      //partnerorderhistorysummary
public static  PURCHASE_ORDER_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/partner/purchase_order_summary'      //partnerpurchaseordersummary
public static  PURCHASE_ORDER_DETAILS = UtilsService. IDENTITY_BASE_URL  + '/partner/purchase_order_details'      //partnerpurchaseorderdetails
public static  GET_MVNO_MAIN_PLANS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_mvno_main_plans'            //partnermvnomainplans
public static  GET_MVNO_TOPUP_PLANS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_mvno_topup_plans'          //partnermvnotopupplans
public static  GET_MVNO_PLAN_DETAILS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_mvno_plan_details'        //partnermvnoplandetails
public static  GET_MVNO_PARTNER_WPS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_mvno_partner_wps'          //partnermvnowps
public static  GET_MVNO_PARTNER_ASYNC_LOGS = UtilsService. IDENTITY_BASE_URL  + '/partner/partner_async_logs'     //partnerasynclogs
public static GET_MVNO_PARTNER_API_LOGS = UtilsService. IDENTITY_BASE_URL  + '/partner/partner_api_logs'                      //partnerpilogs
public static  GET_MVNO_PARTNER_SIM_INVENTORY_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/partner/sim_inventory_summary_details_by_partner_id'   //partnerpilogsbyid
public static GET_MVNO_PARTNER_SIM_INVENTORY_SUMMARY_BY_BATCHNO_STATUS = UtilsService. IDENTITY_BASE_URL  + '/partner/sim_inventory_details_by_batch_number_and_sim_status'
public static  GET_MVNO_PARTNER_ALL_API_TYPES = UtilsService. IDENTITY_BASE_URL  + '/logs/get_mvno_api_type_details'   //partnerallpitypes
public static GET_MVNO_PARTNER_ALL_ASYNC_TYPES = UtilsService. IDENTITY_BASE_URL  + '/logs/get_async_type_details'     //partnerallasynctypes
public static  GET_PENDING_PORTS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_port_pending_order_details'      //pendingports
public static  GET_ACTIVE_PORTS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_active_portin_order_by_msisdn'      //ACTIVEports
public static  PORTIN_CHANGE_MSISDN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/change_msisdn'      //portineligibility
public static GET_PARTNER_CDR_LOGS = UtilsService. IDENTITY_BASE_URL  + '/cdr/partner_cdr_log'      //ACTIVEports
public static GET_MSISDN_CHANGE_LOGS = UtilsService. IDENTITY_BASE_URL +'/noc/change_msisdn_report'  //msisdnchangereport

// Admin APIs
public static  GET_ALL_PARTNERS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_all_mvno_partners'      //ACTIVEports
public static  CREATE_PARTNER = UtilsService. IDENTITY_BASE_URL  + '/partner/mvno_partner'      //ACTIVEports
public static  UPDATE_PARTNER = UtilsService. IDENTITY_BASE_URL  + '/partner/mvno_partner'      //ACTIVEports
public static  NEXUS_USER = UtilsService. IDENTITY_BASE_URL  + '/partner/get_all_mvno_partners'      //ACTIVEports
public static  GET_MVNO_PARTNER_API_LOG_BY_ID = UtilsService. IDENTITY_BASE_URL  + '/logs/partner_api_logs_details_by_id'   //partnerpilogsbyid
public static GET_MVNO_PARTNER_ASYNC_API_LOG_BY_ID = UtilsService. IDENTITY_BASE_URL  + '/logs/partner_async_log_details_by_id' 

public static WHITELIST_USER = UtilsService.IDENTITY_BASE_URL + '/fraud/fraud-whitelist';

public static  ASSIGN_SIMS_BY_BATCHNO = UtilsService. IDENTITY_BASE_URL  + '/siminventory/assign_inventory_to_partner_batch_number'      //ACTIVEports
public static    ASSIGN_SIMS_BY_RANGE= UtilsService. IDENTITY_BASE_URL  + '/siminventory/assign_inventory_to_partner'     
public static  CREATE_SIM_ORDER = UtilsService. IDENTITY_BASE_URL  + '/siminventory/create_order'      //ACTIVEports
public static    UPDATE_SIM_ORDER= UtilsService. IDENTITY_BASE_URL  + '/siminventory/update_order'   
public static    GET_ALL_SIM_ORDERS= UtilsService. IDENTITY_BASE_URL  + '/siminventory/get_all_sim_orders' 
public static  CREATE_SIM_ORDER_BATCH = UtilsService. IDENTITY_BASE_URL  + '/siminventory/create_sim_order_batch'      //ACTIVEports
public static  SIM_REASSIGN = UtilsService. IDENTITY_BASE_URL  + '/siminventory/sim_reassign'      //portineligibility

public static    GET_ALL_SIM_ORDERS_BATCH= UtilsService. IDENTITY_BASE_URL  + '/siminventory/get_all_sim_order_batches' 
public static    GET_ALL_CARRIERS= UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_carriers' 
public static    GET_SIM_MANUFACTURERS= UtilsService. IDENTITY_BASE_URL  + '/siminventory/get_sim_manufacturers' 
public static   GET_PRODUCT_RESTRICTION= UtilsService. IDENTITY_BASE_URL  + '/partner/product_restriction' 
public static    CREATE_PRODUCT_RESTRICTION= UtilsService. IDENTITY_BASE_URL  + '/partner/partnerwps_product_restriction_Create' 
public static  CANCEL_DEVICE_LOCATION = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/cancel_device_location' //nexuscanceldevicelocation
public patch(url: string, object: any): Observable<any> {
      return this.httpClient.patch(url, object);
  }
 
public static UPDATE_FIELD = UtilsService.IDENTITY_BASE_URL+ '/noc/subscriber/{subscriberId}/update_field'
public static GET_NOTES = UtilsService.IDENTITY_BASE_URL + '/subscriber/subscriberid';
public static CREATE_NOTES = UtilsService.IDENTITY_BASE_URL + '/subscriber/subscriberid'
public static UPDATE_NOTES = UtilsService.IDENTITY_BASE_URL + '/subscriber/subscriber/note'

public static USAGE_HISTORY = UtilsService.IDENTITY_BASE_URL+ '/noc/usage_history'
    //ACTIVEports
      //ACTIVEports
 public static  CARRIER_API_LOGS = UtilsService. IDENTITY_BASE_URL  + '/logs/carrier_api_logs'
 public static  PARTNER_API_LOGS = UtilsService. IDENTITY_BASE_URL  + '/logs/partner_api_logs'
  public static  PARTNER_ASYNC_LOGS = UtilsService. IDENTITY_BASE_URL  + '/logs/partner_async_logs'
  public static  CARRIER_ASYNC_LOGS = UtilsService. IDENTITY_BASE_URL  + '/logs/carrier_async_logs'
  public static GET_TMO_CDR_LOGS = UtilsService. IDENTITY_BASE_URL +'/cdr/tmolog'
  public static GET_SURF_CDR_LOGS = UtilsService. IDENTITY_BASE_URL +'/cdr/surflog'
  public static  GET_MVNO_PARTNERS = UtilsService. IDENTITY_BASE_URL  + '/partner/mvno_partners'      //ACTIVEports

  public static  CREATE_PLAN = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/mvno_plan'      //createplan
  public static  UPDATE_PLAN = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/mvno_plan'      //createplan
  public static  GET_PLANS_BY_PARTNER = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/mvno_plans'
  public static  GET_PLANS_BY_PLANCODE = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/mvno_plan'      //ACTIVEports
    public static  GET_PLAN_TYPES = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_mvno_plan_types'
    public static  GET_EXPIRATION_TYPE_BY_PLAN_TYPE = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_Expiration_types_by_plan_type'
     public static  GET_SOCS_BY_TMO_PACKAGE_ID = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_socs_by_tmo_package_id'
     public static  GET_SOCS = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_surf_socs'
     public static  GET_TMO_PACKAGE = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_tmo_package_types'
     public static GET_CARRIER_API_LOG_BY_ID = UtilsService. IDENTITY_BASE_URL  + '/logs/carrier_api_logs_details_by_id' 
     public static GET_CARRIER_ASYNC_LOG_BY_ID = UtilsService. IDENTITY_BASE_URL  + '/logs/carrier_async_logs_details_by_id' 
       public static  GET_PRODUCT_BEHAVIOURS = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/get_product_behaviors'
       public static  CREATE_PARTNER_BILLING_MAPPING = UtilsService. IDENTITY_BASE_URL  + '/partner/create_partner_billing_mapping'
       public static GET_TMO_WPS = UtilsService. IDENTITY_BASE_URL  + '/partner/get_tmo_package_wps'
       public static  UPDATE_PARTNER_BILLING_MAPPING = UtilsService. IDENTITY_BASE_URL  + '/partner/update_partner_billing_mapping'
       public static  RESET_VOICE_MAIL = UtilsService. IDENTITY_BASE_URL  +'/nexusapi/voicemail_password_reset'// UtilsService. IDENTITY_BASE_URL  + '/nexusapi/voicemail_password_reset'      //nexusvoicemail password reset
public static  MSISDN_CHANGE =UtilsService. IDENTITY_BASE_URL  + '/nexusapi/msisdn_change'      //nexus msisdnchange
public static  CHANGE_SIM =UtilsService. IDENTITY_BASE_URL  + '/nexusapi/sim_change' 

public static  CREATE_PARTNER_API_KEY = UtilsService. IDENTITY_BASE_URL  + '/partner/create_partner_api_key'
public static  GET_PARTNER_API_KEY = UtilsService. IDENTITY_BASE_URL  + '/partner/partner_api_keys'

public static  CREATE_SURF_PLAN = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/surfmvno_plan'      //createplan
public static  UPDATE_SURF_PLAN = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/surfmvno_plan' 
  // public static  GET_PLANS_BY_PLANCODE = UtilsService. IDENTITY_BASE_URL  + '/mvnocplan/mvno_plans'
public static IP_WHITE_LIST = UtilsService. IDENTITY_BASE_URL  + '/partner/ip_whitelist'

//   Nexus APIs
public static  QUERY_HLR = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/hlr'   //nexusqueryhlr
public static  NEXUS_USAGE = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/usage'      //nexususage
public static  ACTIVATE_SIM = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/add_customer'      //nexusactivatesim
public static  PURCHASE_PLAN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/plan_purchase'      //nexusactivatesim
public static  CHANGE_PLAN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/plan_change'      //nexusactivatesim
public static  SUSPEND_SUBSCRIBER = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/suspend'      //nexussuspend
public static  RESTORE_SUBSCRIBER = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/restore'      //nexussrestore
public static  DEACTIVATE_SUBSCRIBER = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/deactivate'      //nexusdeactivate
public static  REACTIVATE_SUBSCRIBER = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/reactivate'      //nexusreactivate
public static  VALIDATE_PORTIN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/eligibility'      //portineligibility
public static  QUERY_PORTIN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/status'      //portineligibility
public static  CANCEL_PORTIN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/cancel'      //portineligibility
public static  UPDATE_PORTIN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/update'      //portineligibility
public static  CREATE_PORTIN = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/activate'      //portineligibility
public static ADMIN_UPDATE_SUBSCRIBER_BILLING_CODE = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/billing_code'
public static GET_MVNO_ACTIVE_PLANS = UtilsService. IDENTITY_BASE_URL + '/mvnocplan/active_mvno_plans'

public static  UPLOAD_ACTIVATION_FOOTPRINT = UtilsService. IDENTITY_BASE_URL  + '/partner/import_activation_footprint'  
public static  UPLOAD_FRAUD_FILES = UtilsService. IDENTITY_BASE_URL  + '/fraud/fraud_batch_upload'

public static FRAUD_BATCH_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/fraud/fraud_batch_summary_page' 
public static FRAUD_BATCH_SUMMARY_FILE =  UtilsService.IDENTITY_BASE_URL + '/get_file';
public static  FRAUD_MANUAL_REFRESH = UtilsService. IDENTITY_BASE_URL  + '/fraud/batch' 
public static  GET_FRAUD_DETAILS = UtilsService. IDENTITY_BASE_URL  + '/fraud/fraud_batch_details_page'//portineligibility
public static  UPDATE_FRAUD_BATCH = UtilsService. IDENTITY_BASE_URL  + '/fraud/update_fraud_batch'
public static  GET_SUBSCRIBER_STATUS = UtilsService. IDENTITY_BASE_URL  + '/partner/subscriber_status'
public static  CREATE_INTERNAL_SUBSCRIBER = UtilsService. IDENTITY_BASE_URL  + '/partner/create_subscriber'  
public static  DELETE_BILLING_MAPPING = UtilsService. IDENTITY_BASE_URL  + '/partner/delete_partner_billing_mapping' 
public static GET_FRAUD_TYPES = UtilsService.IDENTITY_BASE_URL +  '/fraud/tmo_fraud_types'
public static FRAUD_TYPE_MAPPING = UtilsService.IDENTITY_BASE_URL + '/fraud/tmo_fraud_mapping'  
public static GET_BATCH_NOTIFICATION_DETAILS = UtilsService.IDENTITY_BASE_URL + '/fraud/notification'
public static GET_BATCH_RENOTIFICATION_DETAILS = UtilsService.IDENTITY_BASE_URL + '/fraud/notification/renotification'

public static ENDPOINT_URL_LIST= UtilsService. IDENTITY_BASE_URL  + '/partner/nexus_endpoints'
public static GET_BLOCKED_PRODUCTSLIST=UtilsService. IDENTITY_BASE_URL  + '/partner/partnerid/{partnerid}/products'
public static BLOCKED_ENDPOINT_URL= UtilsService. IDENTITY_BASE_URL  + '/partner/partner_blocked_nexus_endpoint'
public static BLOCKED_PRODUCTS= UtilsService. IDENTITY_BASE_URL  +'/partner/products'
// contact retrival

public static CONATACT_TYPE = UtilsService. IDENTITY_BASE_URL + '/partner/contact_types'
public static CREATE_CONTACT = UtilsService. IDENTITY_BASE_URL + '/noc/contact/create'
public static RETRIVE_CONTACT = UtilsService. IDENTITY_BASE_URL + '/noc/contacts'
public static UPDATE_CONTACT = UtilsService. IDENTITY_BASE_URL + '/noc/contact_update'


// SIP Apis

public static  SIP_CALL_TYPE_MAPPING = UtilsService. IDENTITY_BASE_URL  + '/sip/calltypemapretrieve'      //portineligibility
public static  SIP_CALL_RECORD_RETRIEVE = UtilsService. IDENTITY_BASE_URL  + '/sip/callrecordretrieve'      //portineligibility
public static SIP_CALL_RECORD_RETRIEVE_TRANSACTIONID = UtilsService. IDENTITY_BASE_URL  + '/sip/callrecordretrievebytransactionid'
public static  SIP_VOICE_CONNECTOR_RETRIEVE = UtilsService. IDENTITY_BASE_URL  + '/sip/voiceconnectorretrieve'
public static  SIP_ENDPOINT_TYPE_RETRIEVE = UtilsService. IDENTITY_BASE_URL  + '/sip/endpointretrieve'      //portineligibility
public static  SIP_MVNOPARTNER_CALLTYPE_CREATE = UtilsService. IDENTITY_BASE_URL  + '/sip/mvnopartnercalltypecreate'
public static  SIP_MVNOPARTNER_CALLTYPE_UPDATE = UtilsService. IDENTITY_BASE_URL  + '/sip/updatemvnopartnercalldetails' 
public static  SIP_MVNOPARTNER_CALLTYPE_RETRIVE = UtilsService. IDENTITY_BASE_URL  + '/sip/mvnopartnercalltypedetailsretrieve'
public static  SIM_INVENTORY_BY_ICCID =UtilsService. IDENTITY_BASE_URL   + '/siminventory/sim_details_by_iccid'  
 public static  SIM_BATCH_DETAILS =UtilsService. IDENTITY_BASE_URL   + '/siminventory/sim_order_batch_details'  

  public static  CARRIER_API_LOGS_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/logs/carrier_api_log_summary'
  public static  PARTNER_API_LOGS_SUMMARY = UtilsService. IDENTITY_BASE_URL  + '/nexusapi/partner_api_log_summary'

  public static GET_ALL_USERS = UtilsService. IDENTITY_BASE_URL  + '/account/partner_users'
  public static GET_ROLES = UtilsService. IDENTITY_BASE_URL  + '/account/get_roles'
  public static CREATE_USER = UtilsService. IDENTITY_BASE_URL  + '/partner/user'
  public static UPDATE_USER = UtilsService. IDENTITY_BASE_URL  + '/account/update_partner_users'

  public static  CREATE_ROLE_MENU = UtilsService. IDENTITY_BASE_URL  + '/menupermission/create_role_menu'
  public static  UPDATE_ROLE_MENU = UtilsService. IDENTITY_BASE_URL  + '/menupermission/update_role_menu'
  public static  CREATE_USER_ROLE = UtilsService. IDENTITY_BASE_URL  + '/account/create_user_role'
  public static  UPDATE_USER_ROLE = UtilsService. IDENTITY_BASE_URL  + '/account/update_user_role'
  public static GET_MENUS = UtilsService. IDENTITY_BASE_URL  + '/menupermission/get_platform_menu_details'
  public static GET_MENUS_BY_ROLE = UtilsService. IDENTITY_BASE_URL  + '/menupermission/get_menus_by_role_id'


  public static GET_FILE = UtilsService.S3_GATEWAY_BASE_URL + '/get_file'
  public static  GET_ASYNC_URLS = UtilsService. IDENTITY_BASE_URL  + '/logs/get_partner_async_url'
  public static  UPDATE_ASYNC_URL = UtilsService. IDENTITY_BASE_URL  + '/logs/partner_async_url'

  
  public static GET_QUERY_PORTORDERS = UtilsService.IDENTITY_BASE_URL + '/partner/port_order/query'
  
  public static CANCEL_PORTORDERBYID = UtilsService.IDENTITY_BASE_URL + '/partner/port_order/cancel'
  

  constructor(private httpClient: HttpClient,private localStorageService: LocalStorageService) {}
// 
  public post(url: string, object: any): Observable<any> {

      return this.httpClient.post(url, object);
  }

  public post_promise(url: string, object: any): Promise<any> {

      return this.httpClient.post(url, object).toPromise();
  }

  public put(url: string, object: any): Observable<any> {

      return this.httpClient.put(url, object);
  }
public get(url: string, payload?: any, responseType: 'json' | 'blob' = 'json'): Observable<any> {
  let params = new HttpParams();
  if (payload) {
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined && payload[key] !== null) {
        params = params.set(key, payload[key]);
      }
    });
  }
  return this.httpClient.get(url, { params, responseType: responseType as any });
}
  // public get(url: string): Observable<any> {
  //     return this.httpClient.get(url);
  // }
// public getWithParams (url: string, params: any): Observable<any> {
// const params1 =  new HttpParams().set('BucketName', params.bucketName).set('Path', params.fileUrl).set('FileName', params.fileName);
//   return this.httpClient.get(url, { params:params1 });
// }
   public delete(url: string,obj:any): Observable<any> {
const options = {

  body: obj
 
   }
      return this.httpClient.delete(url,options);
  }
  async encrypt_Text(data: string): Promise<string | null> {
    if (data == null) {
      return Promise.resolve(null);
    }
    return this.localStorageService.encryptText(data)
      .then(output => output !== null ? output.toString() : null)
      .catch(error => {
        console.error('Encryption failed:', error);
        return null;
      });
  }

  async decrypt_Text(data: string): Promise<string | null> {
    if (data == null) {
      return Promise.resolve(null);
    }
    return this.localStorageService.decryptText(data)
      .then(output => output !== null ? output.toString() : null)
      .catch(error => {
        console.error('Decryption failed:', error);
        return null;
      });
  }





  /****** BackUP CryptoJS */
  // encrypt_Text(data: string) {
  //   if (data == null) {
  //     return null;
  //   }
  //   var output = "";
  //   output = CryptoJS.AES.encrypt(data, "rsygjxzium$#@!").toString();
  //   return output;
  // }

  // decrypt_Text(data: any) {
  //     if (data == null) {
  //         return null;
  //     }
  //     var output = "";
  //     output = CryptoJS.AES.decrypt(data, "rsygjxzium$#@!").toString(CryptoJS.enc.Utf8);
  //     return output;
  // }
  sharedData(object : any)
  {
      this.Datashare.emit(object);
      
  }
}
